import { render, staticRenderFns } from "./LocalRankings.vue?vue&type=template&id=39fa03b6&scoped=true"
import script from "./LocalRankings.vue?vue&type=script&lang=js"
export * from "./LocalRankings.vue?vue&type=script&lang=js"
import style0 from "./LocalRankings.vue?vue&type=style&index=0&id=39fa03b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fa03b6",
  null
  
)

export default component.exports